import { graphHooks } from '@tunasong/graph-lib/react'
import type { Comment, Persisted } from '@tunasong/schemas'
import { useEffect } from 'react'
import type { TaskEntry } from './task-list.js'

/**
 * This entity's own tasks, for the Tasks filter (chat tasks M2.4, GH #3041). The feed pages its comments in, so an
 * older task may not be loaded: one read of every comment, with only what orders and splits them, keeps Tasks whole.
 * It is live, so a tick or a new task shows. Each row then loads its comment's body.
 */
export const useEntityTasks = (entityId: string | undefined): TaskEntry[] => {
  const [loadComments, result] = graphHooks.useLoadChildEntitiesBatch()

  useEffect(() => {
    if (entityId) {
      void loadComments({ parentIds: [entityId], type: 'comment', fields: 'createdAt,task,userId' }, true)
    }
  }, [entityId, loadComments])

  const comments = (entityId ? (result.data ?? []) : []) as Persisted<Comment>[]
  /** While the read follows a new entity, it still holds the last one's */
  return comments.filter(comment => comment.parentId === entityId && comment.task).map(comment => ({ comment }))
}
